import React from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  Typography,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { setDecimalPrecision } from 'utils/helpers'
import { PAYMENT_METHODS_VALUES } from 'utils/constants'
const renderPaymentRows = (payment, pricePrepend) => (
  <TableRow key={payment.id}>
    <TableCell component="th" scope="row">
      {dateFormatter(new Date(`${payment.paymentDate}T00:00:00`))}
    </TableCell>
    <TableCell component="th" scope="row">
      {PAYMENT_METHODS_VALUES[payment?.paymentType?.toUpperCase()] || ''}
    </TableCell>
    <TableCell component="th" scope="row">
      {payment.checkNumber}
    </TableCell>
    <TableCell component="th" scope="row">
      {`${pricePrepend}${setDecimalPrecision(payment.amountPaid, { decimalPrecisionOverride: 2 })}`}
    </TableCell>
  </TableRow>
)

const PrintPaymentsTable = ({ title, paymentInfo, headers, pricePrepend }) => (
  <Grid>
    <Stack direction="row" mb={1}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
    </Stack>

    <TableContainer sx={{ overflow: 'hidden' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {headers.map(header => (
              <TableCell sx={{ fontWeight: 600 }} key={header}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{paymentInfo.Items.map(payment => renderPaymentRows(payment, pricePrepend))}</TableBody>
      </Table>
    </TableContainer>
  </Grid>
)

PrintPaymentsTable.propTypes = {
  title: PropTypes.string,
  paymentInfo: PropTypes.object.isRequired,
  headers: PropTypes.array,
  pricePrepend: PropTypes.string,
}

PrintPaymentsTable.defaultProps = {
  title: '',
  headers: ['Date', 'Payment Method', 'Check #', 'Amount'],
  pricePrepend: '$',
}

export default PrintPaymentsTable
